import React from "react";
import { FaProjectDiagram } from "react-icons/fa";
import "./CustomRuleFindings.css";

/**
 * Renders the admin-authored detection rules that fired for an analyzed email.
 * Driven by the `customRules` field returned by both analysis routes. Shows
 * which rules matched, their effect (raise/suppress), and a muted note when a
 * suppression was blocked by the guardrail (a confirmed threat was present).
 */
export default function CustomRuleFindings({ customRules }) {
  const matches = customRules?.matches;
  if (!Array.isArray(matches) || matches.length === 0) return null;

  return (
    <div className="crf-block">
      <div className="crf-title">
        <FaProjectDiagram />
        <span>Custom Detection Rules</span>
        <span className="crf-count">{matches.length} matched</span>
      </div>
      <ul className="crf-list">
        {matches.map((m) => {
          const cls = m.effect === "suppress" ? "crf-suppress" : "crf-raise";
          const stateLabel = m.applied
            ? m.effect === "suppress" ? "suppressed" : "raised"
            : m.blockedByGuardrail
            ? "not applied — blocked by guardrail"
            : "not applied — verdict already higher";
          return (
            <li key={m.id} className={`crf-item ${cls} ${m.applied ? "" : "crf-inactive"}`}>
              <div className="crf-item-head">
                <span className="crf-name">{m.name}</span>
                <span className={`crf-pill ${cls}`}>
                  {m.effect === "suppress" ? "Suppress" : "Raise"} → {m.verdict}
                </span>
                <span className="crf-state">{stateLabel}</span>
              </div>
              {m.reason && <div className="crf-reason">{m.reason}</div>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
